"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function insertPlacement(group, index, values) {
    var placements = group.mediumGroup;
    var newProperties = {
        medium: values.medium,
        conditions: values.conditions,
        frequency: values.frequency,
        pi: values.pi,
        share: values.share,
        frequencyCapping: values.frequencyCapping,
        additionalData: values.additionalData,
        targeting: values.targeting,
        group: values.group,
        tag: values.tag,
        dates: values.dates,
        period: values.period
    };
    var newPlacement = makePlacement(newProperties);
    var newPlacements = placements.slice();
    newPlacements.splice(index, 0, newPlacement);
    return _.assign({}, group, { mediumGroup: newPlacements });
}
exports.insertPlacement = insertPlacement;
function makePlacement(properties) {
    var clone = _.clone(properties);
    if (_.get(clone, "conditions.online.adFormat") === "AGOF_Werbeform_0") {
        delete clone.targeting;
    }
    return clone;
}
//# sourceMappingURL=insertPlacement.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/datalayerHelpers/insertPlacement.js
// module id = 56
// module chunks = 0